import reducer from './reducers';

export { default as milestonesActions } from './actionCreators';
export { default as milestonesSagas } from './sagas';

export default reducer;
